export enum Tabs {
  DEALS = 'Сделки',
  DOCUMENTS = 'Документы'
}
